import "./EditKeywords.scss";
import { Chip } from "@mui/material";
import { Formik, Field } from "formik";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { axiosInstance } from "../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../Utilities/Constants/ApiEndpoints";
import {
  TOASTER_CONFIGS,
  VALIDATION_CONSTANT,
  ROUTES,
  UPLOAD_TICKET_CONSTANT,
  I18_TRANSLATION_COMMON,
} from "../../../Utilities/Constants/Constants";
import { REGEX } from "../../../Utilities/Constants/Validations";
import plus from "../../../../Assets/tags/plus.svg";
import backButton from "../../../../Assets/schools/back_button.svg";
import { nullUndefinedEmptyCheck } from "../../../Services/Helpers/Helper";
import { List, ListItemButton, ListItemText, MenuItem, Select } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const EditKeywords = () => {
  const [courseType, setCourseType] = useState("");
  const [course, setCourse] = useState("");
  const { t } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const [tagList, setTagList]: any = useState([]);
  const [currentEngTag, setCurrentEngTag] = useState("");
  const [currentArabTag, setCurrentArabTag] = useState("");
  const navigate = useNavigate();

  const location = useLocation();
  const { id, type } = useParams();
  const [ arabictag, setArabictag ] = useState('');
  
  const [ englishtag, Setengilshtag ] = useState("");
  const [ eataglist, setEataglist ]:any = useState([])


 
  const currentLanguage = useSelector((state: any) => {
    return state.languageReducer.language;
  });

    
useEffect(() => {
  const pathName = window.location?.pathname;
  const payload = {
    record_area: pathName.slice(1)
  }
  axiosInstance.post(`${API_END_POINTS?.RECORD_AREA}`, payload).then((response: any) => {
  }).catch(() => {
  })
}, [])

  useEffect(() => {
    location.pathname.split("/")[1] ===
    UPLOAD_TICKET_CONSTANT.MANAGE_RECREATIONAL
      ? setCourseType(VALIDATION_CONSTANT.RECREATION)
      : setCourseType(VALIDATION_CONSTANT.COURSE);

    
  }, []);

  useEffect(() => {
    if (courseType) tageDetail();
  }, [courseType]);

 
  const setEngInputValue = (e: any) => {
    if (REGEX.ENGLISH_INPUT_VALIDATION.test(e.target.value)) {
      setCurrentEngTag(e.target.value);
    }
  };

 
  const setArabicInputValue = (e: any) => {
   
    if (
      REGEX.ARABIC_INPUT_VALIDATION.test(e.target.value) ||
      e.target.value.trim() === ""
    ) {
      setCurrentArabTag(e.target.value);
      return;
    } else {
      e.preventDefault();
      return;
    }
  };

 
  const tageDetail = () => {
    axiosInstance
      .get(
        API_END_POINTS.GET_TAG_DETAIL +
          "?category_type=" +
          courseType +
          "&category_id=" +
          id
      )
      .then((res: any) => {
        if (res.data.status === true) {
          setTagList(res.data.result.data);
          setEataglist(res.data.result.data)
          setCourse(res.data.result.category);
        }
      }
    )
    .catch(()=>{})
    ;
  };

 
  const onUpdateTags = () => {
    axiosInstance
      .put(
        API_END_POINTS.GET_TAG_DETAIL +
          "?category_type=" +
          courseType +
          "&category_id=" +
          id,
        { eatags: eataglist }
      )
      .then((res: any) => {
        if (res.data.status === true) {
          toast.success(res.data.message, TOASTER_CONFIGS);
          setTagList(res.data.result.data);
          navigatePrevious();
        }
      });
  };

 
  const handleDelete = (i: any) => () => {
    setTagList(tagList.filter((item: any, index: any) => index !== i));
  };
 
  const handleKeyPress = (event: any) => {
    if (
      event.key === VALIDATION_CONSTANT.KEY_TYPE &&
      event.target.value.trim() !== ""
    ) {
      onSaveTag();
    }
  };
 
  const onSaveTag = () => {
    let pushPayload = {
      id: "0",
      arabic_tag_name: currentArabTag,
      tag: currentEngTag,
    };
    setTagList([...tagList, pushPayload]);
    setCurrentEngTag("");
  };

  const navigatePrevious = () => {
    courseType === VALIDATION_CONSTANT.RECREATION
      ? navigate(ROUTES.RECREATIONAL_KEYWORDS)
      : navigate(ROUTES.COURSE_KEYWORDS);
  };

  return (
    <div
      className="tag-edit-wrap categories_wrapper"
      dir={currentLanguage === "English" ? "ltr" : "rtl"}
    >
      <div className="update-btn-wrap">
        <img
          className="arrow_icon"
          src={backButton}
          alt="Learn and Play"
          onClick={navigatePrevious}
        />
        <h5 className="name-title">{t("Edit Tags")}</h5>
      </div>
      <div className="tag-form-wrap box-wrapper same-line">
        <div className="col-md-5">
          <div className="tag-input-wrap">
            <label className="tag-name-label">{t("Course Type:")}</label>
            <input className="course-type-input" value={courseType} disabled />
          </div>
          <div className="tag-input-wrap">
            <label className="tag-name-label">{t("Category")}</label>
            <input className="course-type-input" value={course} disabled />
          </div>
        </div>

        <div className="row school-row-wrap">
              <div id="card-title" className="mandatory_fields">{t("Tags")}</div>
              <div className="">
                <div>
                  <div className="application-btn-wrapper">
                    <input
                      className="form_inputs mb-3"
                      placeholder={t("Engilsh Tag")}
                      onChange={(e: any) => {
                        Setengilshtag(e.target.value);
                      }}
                      value={englishtag}
                    />
                    <input
                      className="form_inputs mb-3"
                      placeholder={t("Arabic Tag")}
                      onChange={(e: any) => {
                        setArabictag(e.target.value);
                      }}
                      
                      value={arabictag}
                    />
                    <button
                      type="button"
                      className="btn add-btn"
                      onClick={() => {
                        if (
                          nullUndefinedEmptyCheck(englishtag) &&
                          nullUndefinedEmptyCheck(arabictag)
                        ) {
                          let data: any = eataglist;
                          let obj = {
                            
                            ["id"]:0,
                            ["tag"]:englishtag,
                            ["arabic_tag_name"]:arabictag
                          };
                          data.push(obj);
                          setEataglist([...data]);
                          Setengilshtag("");
                          setArabictag("");
                        }
                      }}
                    >
                      Add
                    </button>
                  </div>
                  {eataglist?.length > 0 && (
                    <div className="">
                      <List>
                        {eataglist.map((point: any, index: any) => {
                          
                          return (
                            <div key={index}>
                              <ListItemButton className="list-btn">
                                <ListItemText primary={`${point.tag} : ${point.arabic_tag_name}`} />
                                <DeleteIcon
                                  onClick={() => {
                                    let data: any = eataglist.slice();
                                    data.splice(index, 1);
                                    setEataglist(data);
                                  }}
                                />
                              </ListItemButton>
                            </div>
                          );
                        })}
                      </List>
                    </div>
                  )}
                  <div className="error-message-wrap mt-2">
                    {eataglist?.length === 0 && (
                      <div className="errorMessage">
                        {t("select correctly")}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

      </div>
      <div className="save-tag">
        <button className="cancel_button" onClick={() => navigatePrevious}>
          {t("Cancel")}
        </button>
        <button className="save_button" onClick={onUpdateTags}>
          {t("Update")}
        </button>
      </div>
    </div>
  );
};

export default EditKeywords;
